module.exports = __webpack_public_path__ + "img/Flaticon.ffd57a33.svg";